import { fetchJson } from '@atlassian/help-center-common-util/fetch';
import { contextPath } from '@atlassian/help-center-common-util/history';
import type { CmdbObjectHttpResponse, CmdbObjectResponse } from './types';

export const fetchCmdbObjectsWithSignal = (
	portalId: number,
	requestTypeId: number,
	fieldId: string,
	inputValue: string,
	fieldValueMap: string[][],
	signal: AbortSignal,
	start: number,
): Promise<CmdbObjectResponse> => {
	const fieldValueMapObject = fieldValueMap.reduce(
		(accumulator: Record<string, string>, field: [string, string]) => {
			if (field[0] !== 'attachment') {
				accumulator[field[0]] = field[1];
			}
			return accumulator;
		},
		{},
	);

	const body = {
		query: inputValue,
		fieldValueMap: fieldValueMapObject,
	};

	return fetchJson<CmdbObjectHttpResponse>(
		`${contextPath}/rest/servicedesk/cmdb/1/customer/portal/${portalId}/request/${requestTypeId}/field/${fieldId}/autocomplete?start=${start}`,
		{
			signal,
			method: 'POST',
			body: JSON.stringify(body),
			headers: { 'Content-Type': 'application/json' },
		},
	).then(({ results, total, hasNextPage }: CmdbObjectHttpResponse) => ({
		total,
		hasNextPage,
		cmdbObjects: results,
	}));
};
